import type { Axios } from "axios";

const singleRoute = "asset";
const route = "assets";

class AssetInterface {
  client: Axios;

  /**
   * constructor to set Axios client
   * @param client Axios client
   */
  constructor(client: Axios) {
    this.client = client;
    this.client.interceptors.request.use((config) => {
      config.params = config.params || {};
      return config;
    });
  }

  /**
   * Get all NFT assets query
   * @param params Object of query params
   */
  async getAll(
    params: { [key: string]: string | number | boolean } = {}
  ): Promise<any> {
    try {
      if (!params["limit"]) {
        params["limit"] = "20";
      }
      if (!params["include_orders"]) {
        params["include_orders"] = false;
      }
      if (!params["order_direction"]) {
        params["order_direction"] = "desc";
      }

      return this.client.get(route, { params }).then((r) => r.data);
    } catch (e: any) {
      console.error("Error ", e);
      throw new Error(e.toString());
    }
  }

  /**
   * Get NFT asset query
   * @param id Asset id
   * @param params Object of query params
   */
  async getAsset(
    assetContract: string,
    id: string,
    params?: { [key: string]: string | number }
  ): Promise<void> {
    try {
      return this.client
        .get(`${singleRoute}/${assetContract}/${id}`, { params })
        .then((r) => r.data);
    } catch (e: any) {
      console.error("Error ", e);
      throw new Error(e.toString());
    }
  }
}
export default AssetInterface;
